<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Popup Confirmation Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6">
              <div class="row">
                <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
                <div class="col-sm-6">
                  <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear" (change)="onYearSelect()">
                    <option value="">Select Year</option>
                    <option *ngFor="let finance of financialYearList" [ngValue]="finance">
                      {{ finance.name }}
                    </option>
                  </select>
                </div>
              </div>
             </div>
            <div class="col-sm-6">
              <div class="row">
                <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
                <div class="col-sm-6">
                  <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedBranch" (change)="onBranchSelect">
                    <option value="">Select Branch</option>
                    <option *ngFor="let branch of branchList" [ngValue]="branch">
                      {{ branch.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
        </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">Date<span class="text-danger">*</span></label>
          <div class="col-sm-6">
            <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedDate">
              <option value="">Select Date</option>
              <option *ngFor="let confirmDate of confirmDateList" [ngValue]="confirmDate">
                {{ confirmDate }}
              </option>
            </select>
          </div>
        </div>
      </div>


        <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()">
              View Report
            </button>
        </div>
         <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onExportToExcelReport()"
              *ngIf="showExcelButton"
            >
              Export To Excel
            </button>
 </div> 
</div>
</div>
</div>

<div class="container" id="mainContent">
<div class="mt-4" id="contentToConvert"  *ngIf="reportList.length>0">
<div class="row justify-content-center text-center mt-4" style="padding-top: 10px;">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>

<div class="row col-md-12 mt-2">
<table class="table table-bordered table-sm table-striped">
    <thead>
        <th>Employee Name</th>
        <th>Asset Name</th>
        <th>Serial Tag Number</th>
        <th>Action Date</th>
        <th>Status</th>
        <th>Reason</th>
    </thead>
   <tbody *ngFor="let data of reportList">
    <td>{{data.firstName}} {{data.middleName}} {{data.lastName}}</td>
    <td>{{data.assetName}}</td>
    <td>{{data.srNumber}}</td>
    <td>{{data.modifiedDate==null?'NA':data.modifiedDate}}</td>
    <td>{{data.statu}}</td>
    <td>{{data.reason==null?'NA':data.reason}}</td>
  </tbody>
 </table> 
</div>
</div>
    </div>
</div>
